export const tableSettings = {
	defaults: {
		sortable: false,
		align: 'center',
		width: 'auto'
	}
}